/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import S3 from 'react-aws-s3';
import UploadDocumentModal from './Modals/uploadDocumentsModal';
import { CamelCase, PriceHandler } from '../../redux/helper/CamelCase';
import { distributorService } from '../../service/distributor.service';
import { Invoiceconfig } from '../../redux/helper/upload-config';
import HeaderContext from '../../Components/Context/HeaderContext';
import ViewandDownloadModal from './Modals/viewandDownloadModal';
import UpdateInvoiceInformationModal from './Modals/updateInvoiceInformationModal';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function InvoicesListing({
    invoiceList, setinvoiceList, isEditId, setisEditId, sortType, setsortType, emptyData, setEmptyData, searchValue, handleFetchInvoices,

}) {
    // const [actionButton, setActionButton] = useState('');
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const uploadInvoiceprevilegeassigned = AccessPrevilegesFunction('invoices:upload');
    const updateInvoiceprevilegeassigned = AccessPrevilegesFunction('invoices:update_payment');

    const ReactS3Client = new S3(Invoiceconfig);
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState({});
    const [viewandDownloadModal, setViewandDownloadModal] = useState(false);
    const [subitButtonDisable, setSubitButtonDisable] = useState(false);
    const [threedotsLoader, setthreedotsLoader] = useState(false);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [documentDetails, setDocumentDetails] = useState({});
    const [uploadInvoiceDocumentsModal, setInvoiceUploadDocumentsModal] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState({});
    const [documentNumbers, setDocumentNumbers] = useState({
        eway_bill_number: '',
        lr_number: '',

    });
    const [noteToolTip, setNoteToolTip] = useState('');
    const [updateInvoiceModal, setUpdateInvoiceModal] = useState(false);
    const [updateInvoiceInformation, setUpdateInvoiceInformation] = useState({
        payment_note: '',
        payment_ref_no: '',
        payment_type: '',
        payment_mode: '',
    });
    const [errorState, setErrorState] = useState({
        invoice: '',
        e_way_bill: '',
        eway_bill_number: '',
        lr_copy: '',
        lr_number: '',
    });
    const [errorIndication, setErrorIndication] = useState(false);

    const InputChange = (e, key) => {
        e.preventDefault();
        const { id, value } = e.target;
        setDocumentNumbers((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const updatevalidate = () => {
        let isvalid = true;
        Object.keys(updateInvoiceInformation).forEach((value) => {
            switch (value) {
            case 'payment_note':
            case 'payment_ref_no':
            case 'payment_type':
            case 'payment_mode':
                if (updateInvoiceInformation[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                    setErrorIndication(true);
                } else {
                    setErrorIndication(false);
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    const handleDelete = (key) => {
        const dataCopy = { ...documentDetails };
        switch (key) {
        case 'invoice':
            delete dataCopy.invoice;
            break;
        case 'lr_copy':
            delete dataCopy.lr_copy;
            break;
        case 'e_way_bill':
            delete dataCopy.e_way_bill;
            break;
        default:
            break;
        }
        setDocumentDetails(dataCopy);
    };

    const handleUploadedFiles = (val, key) => {
        const dataCopy = { ...documentDetails };
        dataCopy[key] = val;
        setDocumentDetails(dataCopy);
    };

    const handleUploadDoc = (e, key) => {
        const files = e.target.files[0];
        // if (files.length === 0) {
        //     return;
        // }
        ReactS3Client.uploadFile(files, files.name)
            .then((data) => {
                handleUploadedFiles(data.key, key);
            })
            .catch((err) => err);
    };

    const validate = () => {
        let isvalid = false;
        for (let index = 0; index < Object.values(documentNumbers).length; index++) {
            if (Object.values(documentNumbers)[index] !== '') {
                isvalid = true;
                break;
            }
        }
        for (let index = 0; index < Object.values(documentDetails).length; index++) {
            if (Object.values(documentDetails)[index] !== '') {
                isvalid = true;
                break;
            }
        }
        if (isvalid === false) {
            setErrorIndication(true);
        } else {
            setErrorIndication(false);
        }
        return isvalid;
    };

    const handleUploadDocuments = async (e, orderNumber, invoiceNumber) => {
        e.preventDefault();
        if (validate()) {
            setsubmitSelected(false);
            const payload = {
                invoice: documentDetails.invoice || '',
                e_way_bill: documentDetails.e_way_bill || '',
                eway_bill_number: documentNumbers.eway_bill_number || '',
                lr_copy: documentDetails.lr_copy || '',
                lr_number: documentNumbers.lr_number || '',
            };
            const res = await distributorService.UploadInvoiceDocuments(orderNumber, invoiceNumber, payload);
            if (!res.error && res.data.success_status) {
                setthreedotsLoader(true);
                setInvoiceUploadDocumentsModal(false);
                setthreedotsLoader(false);
                setDocumentDetails({});
                setDocumentNumbers({});
                SetSuccessMessage(res.message.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setsubmitSelected(false);
            } else {
                setInvoiceUploadDocumentsModal(false);
                setDocumentDetails({});
                setDocumentNumbers({});
                SetSuccessMessage(res.message.message);
                setcolorValue('red');
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue('');
                }, 2000);
            // SetErrorMessage()
            }
        }
    };

    const handleUpdateInvoiceinformation = async () => {
        if (updatevalidate()) {
            setSubitButtonDisable(true);
            const payload = {
                payment_note: updateInvoiceInformation.payment_note,
                payment_ref_no: updateInvoiceInformation.payment_ref_no,
                payment_status: updateInvoiceInformation.payment_type,
                payment_mode: updateInvoiceInformation.payment_mode,
            };
            const res = await distributorService.UploadInvoiceDocuments(selectedInvoice.INDENT_NUMBER, selectedInvoice.INVOICE_NO, payload);
            if (!res.error) {
                SetSuccessMessage('Documents Uploaded Successfully');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            } else {
                SetErrorMessage(res.message.message);
                setcolorValue('red');
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue('');
                }, 2000);
            }
            setUpdateInvoiceModal(false);
            setUpdateInvoiceInformation((prevState) => ({
                ...prevState,
                payment_note: '',
                payment_ref_no: '',
                payment_type: '',
                payment_mode: '',
            }));
            handleFetchInvoices();
            setSubitButtonDisable(false);
        }
    };

    const handleViewInvoiceDetails = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        if (!res.error && res.data.success_status) {
            setViewInvoiceDetails(res.data.data);
            setViewandDownloadModal(true);
        } else {
            SetErrorMessage(res.message.message);
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    const handleViewInvoiceDetailsUpload = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        if (!res.error && res.data.success_status) {
            setViewInvoiceDetails(res.data.data);
            setDocumentNumbers({
                eway_bill_number: res.data.data.eway_bill_number || '',
                lr_number: res.data.data.eway_bill_number || '',
            });
            setDocumentDetails({
                e_way_bill: res.data.data.e_way_bill || '',
                invoice: res.data.data.invoice || '',
                lr_copy: res.data.data.lr_copy || '',
            });
            setInvoiceUploadDocumentsModal(true);
        } else {
            SetErrorMessage(res.message.message);
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    return (
        <div>
            <div
                className="overflow-auto dropdown-menu pb-7 relative z-10"
                style={{ height: 'calc(100vh - 298px)' }}
            >
                <table className="w-full table-auto relative">
                    <thead className="sticky top-0 left-0 z-[2]">
                        <tr className="bg-[#555259] h-10">
                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[142px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                    Invoice No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[168px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    E-waybill No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[184px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Code
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[184px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Name
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px] text-center">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Invoice Date
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'INVOICE_DATE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'INVOICE_DATE+asc') {
                                                    setsortType('INVOICE_DATE+desc');
                                                } else if (sortType === 'INVOICE_DATE+desc') {
                                                    setsortType('INVOICE_DATE+asc');
                                                } else {
                                                    setsortType('INVOICE_DATE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer PO Number
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Category
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transporter Name
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Date
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'ORDER_ACCEPTANCE_DATE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'ORDER_ACCEPTANCE_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'ORDER_ACCEPTANCE_DATE+asc') {
                                                    setsortType('ORDER_ACCEPTANCE_DATE+desc');
                                                } else if (sortType === 'ORDER_ACCEPTANCE_DATE+desc') {
                                                    setsortType('ORDER_ACCEPTANCE_DATE+asc');
                                                } else {
                                                    setsortType('ORDER_ACCEPTANCE_DATE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Acceptance No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[240px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Shipped From
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[240px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Shipped to
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px] pl-[15px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Invoice Value
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'INVOICE_VALUE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'INVOICE_VALUE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'INVOICE_VALUE+asc') {
                                                    setsortType('INVOICE_VALUE+desc');
                                                } else if (sortType === 'INVOICE_VALUE+desc') {
                                                    setsortType('INVOICE_VALUE+asc');
                                                } else {
                                                    setsortType('INVOICE_VALUE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[172px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Payment Status
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[272px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Invoice Ref. No. & Comment
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[300px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Virtual Payment Ref. No. & Comment
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-[5px] px-7 min-w-[66px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceList.length > 0 && invoiceList.map((invoice, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                <td
                                    className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 flex justify-center items-center pt-4 z-[1]"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.45)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    {invoice?.TRX_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.WAYBILL_NUMBER === null ? '-' : invoice?.WAYBILL_NUMBER }
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                    {invoice?.CUSTOMER_CODE}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.CUST_ACCOUNT_NAME}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {moment(invoice?.INVOICE_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('DD-MMM-YYYY, HH:mm:ss')}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.CUST_PO_NUMBER || '-'}
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                    {invoice?.ORDER_CATEGORY}
                                </td>
                                <td className="text-sm font-normal more-lines text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.TRANSPORTER_NAME === null ? '-' : invoice?.TRANSPORTER_NAME}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.INDENT_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {moment(invoice?.ORDER_DATE, 'ddd, DD MMM YYYY HH:mm:ss [GMT]').format('DD-MMM-YYYY, HH:mm:ss')}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.ORDER_ACCEPTANCE_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.SHIP_FROM}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.SHIP_TO}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-end">
                                    {PriceHandler(invoice?.INVOICE_VALUE)}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.PAYMENT_STATUS === null ? 'PENDING' : invoice?.PAYMENT_STATUS }
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                    {invoice?.PAYMENT_NOTE
                                        ? (
                                            <p
                                                className="max-w-sm truncate"
                                                onMouseEnter={() => setNoteToolTip(`payment-${i}`)}
                                                onMouseLeave={() => {
                                                    setTimeout(() => {
                                                        setNoteToolTip('');
                                                    }, 2000);
                                                }}
                                            >
                                                {invoice?.PAYMENT_NOTE && (invoice?.PAYMENT_NOTE.length > 35 ? `${invoice?.PAYMENT_NOTE.slice(0, 35)}...` : `${invoice?.PAYMENT_NOTE}`)}
                                            </p>
                                        )
                                        : <p className="max-w-sm truncate text-center">-</p>}
                                    {invoice?.PAYMENT_NOTE
                                        && (
                                            <div id="tooltip-information" role="tooltip" className={`inline-block absolute  ${noteToolTip === `payment-${i}` ? 'show' : 'invisible'}  z-10 px-0.5 py-[5px] bg-[#A5A5A5] rounded-lg shadow-s2 w-[274px]`}>
                                                <p className="text-sm font-normal text-[#ffffff] cursor-pointer text-center break-words">
                                                    {invoice?.PAYMENT_NOTE}
                                                </p>
                                            </div>
                                        )}
                                </td>
                                <td className="text-sm font-normal max-w-sm truncate text-[#090406] py-[5px] px-7">
                                    {invoice?.VIRTUAL_PAYMENT_NOTE
                                        ? (
                                            <p
                                                className="max-w-sm truncate"
                                                onMouseEnter={() => setNoteToolTip(`virtual_note-${i}`)}
                                                onMouseLeave={() => {
                                                    setTimeout(() => {
                                                        setNoteToolTip('');
                                                    }, 2000);
                                                }}
                                            >
                                                {invoice?.VIRTUAL_PAYMENT_NOTE && (invoice?.VIRTUAL_PAYMENT_NOTE.length > 35 ? `${invoice?.VIRTUAL_PAYMENT_NOTE.slice(0, 35)}...` : `${invoice?.VIRTUAL_PAYMENT_NOTE}`)}

                                            </p>
                                        )
                                        : <p className="max-w-sm truncate text-center">-</p>}
                                    <div id="tooltip-information" role="tooltip" className={`inline-block absolute  ${noteToolTip === `virtual_note-${i}` ? 'show' : 'invisible'}  z-10 px-0.5 py-[5px] bg-[#A5A5A5] rounded-lg shadow-s2 w-[274px]`}>
                                        <p className="text-sm font-normal text-[#ffffff] cursor-pointer text-center break-words">
                                            {invoice?.VIRTUAL_PAYMENT_NOTE}
                                        </p>
                                    </div>
                                </td>
                                <td
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                    data-testid={`view-btn-${i}`}
                                    className="py-2.5 px-7 sticky right-0 bg-[#ffffffe6] z-[1]"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.45)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                    </button>
                                    {isEditId !== '' && (
                                        <ul className={`dropdown-menu min-w-[260px] absolute ${isEditId === i ? 'show' : 'hidden'} top-0 right-12 bg-[#FFFFFF] rounded-[10px] shadow-s2`} aria-labelledby="actionButton">
                                            <li
                                                className="inline-block dropdown-item w-full py-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#update-category"
                                                onClick={() => handleViewInvoiceDetails(invoice?.INVOICE_NO)}
                                            >
                                                <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                    View and Download
                                                </p>
                                            </li>
                                            {updateInvoiceprevilegeassigned && (invoice?.PAYMENT_STATUS === null || invoice?.PAYMENT_STATUS === 'PENDING' || invoice?.PAYMENT_STATUS === 'PARTIAL') && (
                                                <li
                                                    className="inline-block dropdown-item w-full py-2"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#updateInvoice"
                                                    onClick={() => { setUpdateInvoiceModal(true); setSelectedInvoice(invoice); }}
                                                >
                                                    <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                        Update Invoice Information
                                                    </p>
                                                </li>
                                            )}
                                            {uploadInvoiceprevilegeassigned
                                            && (
                                                <li
                                                    className="inline-block dropdown-item w-full py-2"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#uploadInvoice"
                                                    onClick={() => { setSelectedInvoice(invoice); handleViewInvoiceDetailsUpload(invoice?.INVOICE_NO); }}
                                                >
                                                    <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                        Upload Invoice Documents
                                                    </p>
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </td>
                            </tr>

                        ))}

                    </tbody>
                </table>
            </div>
            {uploadInvoiceDocumentsModal && (
                <UploadDocumentModal
                    uploadInvoiceDocumentsModal={uploadInvoiceDocumentsModal}
                    setInvoiceUploadDocumentsModal={setInvoiceUploadDocumentsModal}
                    // invoiceNumber={invoice?.invoice_number}
                    // orderNumber={invoice?.order_number}
                    InputChange={InputChange}
                    documentDetails={documentDetails}
                    setDocumentDetails={setDocumentDetails}
                    documentNumbers={documentNumbers}
                    setDocumentNumbers={setDocumentNumbers}
                    handleUploadDoc={handleUploadDoc}
                    handleUploadDocuments={handleUploadDocuments}
                    handleDelete={handleDelete}
                    setthreedotsLoader={setthreedotsLoader}
                    threedotsLoader={threedotsLoader}
                    submitSelected={submitSelected}
                    setsubmitSelected={setsubmitSelected}
                    selectedInvoice={selectedInvoice}
                    setErrorIndication={setErrorIndication}
                    errorIndication={errorIndication}
                />
            )}

            {viewandDownloadModal && (
                <ViewandDownloadModal
                    viewandDownloadModal={viewandDownloadModal}
                    setViewandDownloadModal={setViewandDownloadModal}
                    viewInvoiceDetails={viewInvoiceDetails}
                    setViewInvoiceDetails={setViewInvoiceDetails}
                />
            )}

            {updateInvoiceModal && (
                <UpdateInvoiceInformationModal
                    updateInvoiceModal={updateInvoiceModal}
                    setUpdateInvoiceModal={setUpdateInvoiceModal}
                    updateInvoiceInformation={updateInvoiceInformation}
                    setUpdateInvoiceInformation={setUpdateInvoiceInformation}
                    handleUpdateInvoiceinformation={handleUpdateInvoiceinformation}
                    setErrorIndication={setErrorIndication}
                    errorIndication={errorIndication}
                    subitButtonDisable={subitButtonDisable}
                />
            )}

        </div>

    );
}

export default InvoicesListing;
